export default "__VITE_ASSET__xrj6TB7j__"